import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import VpnManager from './pages/VpnManager';
import './App.css';

function App() {
  const { isLoading, isAuthenticated, loginWithRedirect, error } = useAuth0();

  if (isLoading) {
    return (
      <div className="centered">
        <div className="spinner" />
        <p>Loading…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="centered">
        <p className="error">Auth error: {error.message}</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="login-page">
        <div className="login-card">
          <img src="/images/logo.png" alt="LarbiConnect" className="login-logo" />
          <p>VPN Access Portal</p>
          <button className="btn-primary" onClick={() => loginWithRedirect()}>
            Sign In
          </button>
        </div>
      </div>
    );
  }

  return <VpnManager />;
}

export default App;
